var map = {
	"./X.svg": "./images/icons/X.svg",
	"./arrow.svg": "./images/icons/arrow.svg",
	"./calendar.svg": "./images/icons/calendar.svg",
	"./chevron-down.svg": "./images/icons/chevron-down.svg",
	"./chevron.svg": "./images/icons/chevron.svg",
	"./clock-white.svg": "./images/icons/clock-white.svg",
	"./clock.svg": "./images/icons/clock.svg",
	"./cog.svg": "./images/icons/cog.svg",
	"./cultivation.svg": "./images/icons/cultivation.svg",
	"./facebook.svg": "./images/icons/facebook.svg",
	"./family-friendly.svg": "./images/icons/family-friendly.svg",
	"./full-screen.svg": "./images/icons/full-screen.svg",
	"./hospitality.svg": "./images/icons/hospitality.svg",
	"./information.svg": "./images/icons/information.svg",
	"./instagram.svg": "./images/icons/instagram.svg",
	"./integrity.svg": "./images/icons/integrity.svg",
	"./linkedin.svg": "./images/icons/linkedin.svg",
	"./mail.svg": "./images/icons/mail.svg",
	"./minus.svg": "./images/icons/minus.svg",
	"./openness.svg": "./images/icons/openness.svg",
	"./phone.svg": "./images/icons/phone.svg",
	"./pin-white.svg": "./images/icons/pin-white.svg",
	"./pin.svg": "./images/icons/pin.svg",
	"./pinterest.svg": "./images/icons/pinterest.svg",
	"./plus.svg": "./images/icons/plus.svg",
	"./search.svg": "./images/icons/search.svg",
	"./shared-passion.svg": "./images/icons/shared-passion.svg",
	"./shopping-bag.svg": "./images/icons/shopping-bag.svg",
	"./threads.svg": "./images/icons/threads.svg",
	"./ticket.svg": "./images/icons/ticket.svg",
	"./tube.svg": "./images/icons/tube.svg",
	"./twitter.svg": "./images/icons/twitter.svg",
	"./wifi.svg": "./images/icons/wifi.svg",
	"./youtube.svg": "./images/icons/youtube.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./images/icons sync recursive ^\\.\\/.*\\.svg$";